import TPremiaCard from "@/components/t-premia-card/t-premia-card"
import { ContentInfoPostStyled, ContentItemStyled, ContentStyled, TextLinkStyled, TitleStyled } from "./style-component";
import { CheckOutlined } from "@ant-design/icons";
import { AccountTargetSupportedSocialMedia } from "@/types/account-targert-supported-social-media/account-targert-supported-social-media";
import SocialMediaCard from "@/components/social-media-card/social-media-card";

const PostSuccessCard: React.FC<{ socialMediaSelected: AccountTargetSupportedSocialMedia | undefined, urlPost: string | undefined }> = ({ socialMediaSelected, urlPost }) => {

  const { name } = socialMediaSelected ?? {};
  return (
    <TPremiaCard variant="dark" style={{ gap: '0px', padding: '0px', margin: '0px', minHeight: '300px' }}>
      <ContentStyled>
        <ContentItemStyled>
          <TitleStyled>
            1. Publicar en {socialMediaSelected?.name}
          </TitleStyled>
          <CheckOutlined className="icon-complete" />
        </ContentItemStyled>
        <ContentItemStyled style={{ alignItems: 'center' }}>
          <ContentInfoPostStyled>
            <p className="title-invite">Invita a reaccionar y compartir</p>
            {urlPost && 
            <SocialMediaCard 
              url={urlPost} 
              style={{ maxWidth: '100%' }}
              socialMediaName={String(name).toUpperCase()} 
            />}
          </ContentInfoPostStyled>
        </ContentItemStyled>
      </ContentStyled>
      <TextLinkStyled to="" >Términos y condiciones</TextLinkStyled>
    </TPremiaCard>
  )
}

export default PostSuccessCard;
